import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
    children: JSX.Element;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
    const isLoggedIn = !!localStorage.getItem("token");

    if (!isLoggedIn) {
        return <Navigate to="/login" replace />; // redirect to login
    }

    return children; // user is logged in, render the page
}
